import React from "react";

const List = ({ width = 25, height = 24, fill = "#123051", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0)">
      <path
        d="M20.6215 3.44444V20.5556H3.51036V3.44444H20.6215ZM21.9659 1H2.16592C1.55481 1 1.06592 1.48889 1.06592 2.1V21.9C1.06592 22.3889 1.55481 23 2.16592 23H21.9659C22.4548 23 23.0659 22.3889 23.0659 21.9V2.1C23.0659 1.48889 22.4548 1 21.9659 1ZM10.8437 5.88889H18.177V8.33333H10.8437V5.88889ZM10.8437 10.7778H18.177V13.2222H10.8437V10.7778ZM10.8437 15.6667H18.177V18.1111H10.8437V15.6667ZM5.95481 5.88889H8.39925V8.33333H5.95481V5.88889ZM5.95481 10.7778H8.39925V13.2222H5.95481V10.7778ZM5.95481 15.6667H8.39925V18.1111H5.95481V15.6667Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="24" height="24" fill="white" transform="translate(0.065918)" />
      </clipPath>
    </defs>
  </svg>
);

export default List;